import React from 'react'
import getConfig from 'next/config'
import HeroBanner from '../components/HeroBanner'
import Section from '../components/Section'
import SectionHtml from '../components/SectionHtml'
import VideoBanner from '../components/VideoBanner'
import Carousel from '../components/Carousel'
import MixedContentBanner from '../components/MixedContentBanner'
import FeaturedCarousel from '../components/FeaturedCarousel'
import ResponsiveImage from '../components/ResponsiveImage'
import FullWidthBanner from '../components/FullWidthBanner'
import FeaturedRecipe from '../components/FeaturedRecipe'
import FeaturedContent from '../components/FeaturedContent'
import ProductBanner from '../components/ProductBanner'
import TwoColumnGrid from '../components/TwoColumnGrid'
import PhotoSections from '../components/PhotoSections'
import IconSections from '../components/IconSections'
import InspirationGrid from '../components/InspirationGrid'
import Testimonials from '../components/Testimonials'
import LogoShowcase from '../components/LogoShowcase'
import HeaderBanner from '../components/HeaderBanner'
import ImageList from '../components/ImageList'
import PageCover from '../components/PageCover'
import Newsletter from '../components/Newsletter'
import Contact from '../components/Contact'
import Categories from '../components/Categories'
import SolutionFeatures from '../components/SolutionFeatures'
import FlipGrid from '../components/FlipGrid'
import LogoGrid from '../components/LogoGrid'
import TimelineSection from '../components/TimelineSection'
import Accordion from '../components/Accordion'
import InPageNavigation from '../components/InPageNavigation'
import TestimonialsSlider from '../components/TestimonialsSlider'
import PageTiles from '../components/PageTiles'
import PopUp from '../components/Popup'
import TwoColumnStats from '../components/TwoColumnStats'
import ReviewsCarousel from '../components/ReviewsCarousel'
import YotpoReviews from '../components/YotpoReviews'
import ContactImproved from '../components/ContactImproved'
import { DividerShapeBanner } from '../components/DividerShapeBanner'
import InstagramWidget from '../components/InstagramWidget'
import NoSSR from '../helpers/nossr'

export default function Render({ pageComponents, translations, entryUid, locale, product_data = null }: any) {
  const { publicRuntimeConfig } = getConfig()
  return (
    <div data-pageref={entryUid} data-locale={locale}>
      {pageComponents?.map((component: any, key: any) => {

        if (component.hero_banner)
          return <HeroBanner
            hero_banner={component.hero_banner}
            key={`component-${key}`}
          />

        if (component.section)
          return <Section
            section={component.section}
            key={`component-${key}`}
          />

        if (component.hero_carousel)
          return <Carousel
            full={component.hero_carousel.full_height}
            items={component.hero_carousel.carousel_items}
            key={`component-${key}`}
          />

        if (component.inspiration_grid)
          return <InspirationGrid
            data={component.inspiration_grid}
            key={`component-${key}`} />

        if (component.header_banner)
          return <HeaderBanner
            item={component.header_banner}
            key={`component-${key}`}
          />

        if (component.featured_products)
          return <FeaturedCarousel
              carousel={component.featured_products}
              key={`component-${key}`}
              path="products"
              style={{ '--gradient': 'none' }}
            />

        if (component.featured_recipes)
          return <FeaturedCarousel
            carousel={component.featured_recipes}
            path="recipes"
            key={`component-${key}`}
            style={{}}
          />

        if (component.full_width_banner)
          return <FullWidthBanner
            item={component.full_width_banner}
            key={`component-${key}`}
          />

        if (component.mixed_content_banner)
          return <MixedContentBanner
            item={component.mixed_content_banner}
            key={`component-${key}`}
          />

        if (component.product_banner)
          return <ProductBanner
            item={component.product_banner}
            key={`component-${key}`}
          />

        if (component.testimonial)
          return <Testimonials
            testimonial={component.testimonial}
            key={`component-${key}`}
          />

        if (component.contact_us)
          return <Newsletter
            item={component.contact_us}
            key={`component-${key}`}
          />

        if (component.video_banner)
          return <VideoBanner
            data={component.video_banner}
            key={`component-${key}`}
          />

        if (component.responsive_image)
          return <ResponsiveImage
            data={component.responsive_image}
            key={`component-${key}`}
          />

        if (component.page_cover)
          return <PageCover
            data={component.page_cover}
            locale={locale}
            key={`component-${key}`} />

        if (component.icon_sections)
          return <IconSections
            data={component.icon_sections}
            key={`component-${key}`} />

        if (component.photo_sections)
          return <PhotoSections
            data={component.photo_sections}
            key={`component-${key}`} />

        if (component.categories)
          return <Categories
            data={component.categories}
            key={`component-${key}`} />

        if (component.logo_showcase)
          return <LogoShowcase
            data={component.logo_showcase}
            key={`component-${key}`} />

        if (component.image_list)
          return <ImageList
            data={component.image_list}
            key={`component-${key}`} />

        if (component.solution_features)
          return <SolutionFeatures
            data={component.solution_features}
            key={`component-${key}`} />

        if (component.two_column_grid)
          return <TwoColumnGrid
            data={component.two_column_grid}
            key={`component-${key}`} />

        if (component.rich_text)
          return <SectionHtml
            embedCode={component.rich_text}
            key={`component-${key}`} />

        if (component.contact_form) {
          if (publicRuntimeConfig.useImprovedContactForm) {
            return <ContactImproved
              data={component.contact_form}
              translations={translations?.contact_us}
              key={`component-${key}`} />
          }
          return <Contact
            data={component.contact_form}
            translations={translations?.contact_us}
            key={`component-${key}`} />
        }

        if (component.featured_recipe)
          return <FeaturedRecipe
            recipe={component.featured_recipe.recipe?.[0]}
            translations={translations}
            key={`component-${key}`} />

        if (component.featured_content)
          return <FeaturedContent
            content={component.featured_content}
            key={`component-${key}`} />

        if (component.extended_components)
          return <Render
            pageComponents={component.extended_components?.components}
            entryUid={component.extended_components?._metadata?.uid}
            translations={translations}
            key={`component-${key}`}
            locale={locale} />

        if (component.flip_grid) {
          return <FlipGrid
            fields={component.flip_grid}
            key={`component-${key}`} />
        }

        if (component.timeline_section)
          return <TimelineSection
            data={component.timeline_section}
            translations={translations}
            key={`component-${key}`} />

        if (component.logo_grid)
          return <LogoGrid
            data={component.logo_grid}
            key={`component-${key}`} />

        if (component.in_page_navigation)
          return <InPageNavigation
            data={component.in_page_navigation}
            key={`component-${key}`} />

        if (component.page_tiles)
          return <PageTiles
            data={component.page_tiles}
            key={`component-${key}`} />

        if (component.testimonials_slider)
          return <TestimonialsSlider
            data={component.testimonials_slider}
            key={`component-${key}`} />

        if (component.accordion)
          return <Accordion
            data={component.accordion}
            key={`component-${key}`} />

        if (component.pop_up)
          return <PopUp
            data={component.pop_up}
            key={`component-${key}`}
          ></PopUp>

        if (component.two_column_stats)
          return <TwoColumnStats
            data={component.two_column_stats}
            key={`component-${key}`} />

        if (component.reviews_carousel)
          return <ReviewsCarousel
            data={component.reviews_carousel}
            key={`component-${key}`} />

        if(component.reviews) {
          const reviews_component = component.reviews;
          return <YotpoReviews
            data={{ component: reviews_component, product_data: product_data }}
            key={`component-${key}`} />
        }

        if(component.divider_shape_banner) {
          return <DividerShapeBanner
            title={component.divider_shape_banner?.title}
            description={component.divider_shape_banner?.description}
            key={`component-${key}`} />
        }

        if (component.instagram_widget) {
          return <NoSSR key={`nossr-${key}`}>
            <InstagramWidget
              data={component.instagram_widget}
              key={`component-${key}`} />
          </NoSSR>
        }

        // In development, show unmatched CMS component data for debugging.
        // In production, silently skip unrecognized components.
        if (process.env.NODE_ENV !== 'production') {
          return (
            <div key={`component-${key}`} style={{ margin: '0 auto 2rem', padding: '1rem', maxWidth: 'calc(100vw - 60px)', border: '1px rgba(0,0,0,0.2) solid', background: 'rgba(0,0,0,0.05)' }}>
              <div style={{ margin: '0 0 1rem 0', fontWeight: 'bold' }}>Component: {Object.getOwnPropertyNames(component)}</div>
              <div style={{ width: '100%', overflowX: 'auto' }}><pre style={{ wordBreak: 'break-all' }}>{JSON.stringify(component[Object.getOwnPropertyNames(component)[0]], null, 2)}</pre></div>
            </div>)
        }

        return null
      })}
    </div>
  )
}
